export function parseMarkdownMarkup(str) {
  if (!str) return ''

  return str
    .replace(/(\r\n|\n|\r)/gm, '')
    .replace(/<em>/g, '<i>')
    .replace(/<\/em>/g, '</i>')
    .replace(/<\/ em>/g, '</i>')
    .replace(/<b>/g, '<strong>')
    .replace(/<\/b>/g, '</strong>')
    .replace(/<\/ b>/g, '</strong>')
    .replace(/<br \/>/g, '<br>')
    .replace(/<br\/>/g, '<br>')
    .replace(/&#39;/g, "'")
    .replace(/&quot;/g, '"')
}

export function slugify(str) {
  str = str.replace(/^\s+|\s+$/g, '-') // spaces are dashes
  str = str.toLowerCase()

  // remove accents, swap ñ for n, etc
  const from = 'åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;'
  const to = 'aaaaaaeeeeiiiioooouuuunc------'

  from.split('').map((char, i) => {
    str = str.replace(new RegExp(char, 'g'), to.charAt(i))
  })

  str = str
    .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-') // collapse dashes
    .replace(/^-+/, '') // trim - from start of text
  // .replace(/-+$/, "") // trim - from end of text

  return str
}

export function trimProtocol(str) {
  if (!str) return ''

  return str.replace(/(^\w+:|^)\/\//, '')
}
